const normalizeDurationFromSeconds = (seconds) => {
  const totalSeconds = Number(seconds);
  if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) {
    return "00:42";
  }

  const rounded = Math.round(totalSeconds);
  const minutes = Math.floor(rounded / 60);
  const rem = rounded % 60;
  return `${String(minutes).padStart(2, "0")}:${String(rem).padStart(2, "0")}`;
};

const normalizeDurationFromText = (raw) => {
  if (!raw || typeof raw !== "string") {
    return "";
  }

  const cleaned = raw.trim();
  if (!cleaned) {
    return "";
  }

  const mmssMatch = cleaned.match(/^(\d{1,2}):(\d{2})$/);
  if (mmssMatch) {
    return `${mmssMatch[1].padStart(2, "0")}:${mmssMatch[2]}`;
  }

  const secondsText = cleaned.match(/^(\d{1,4})$/);
  if (secondsText) {
    return normalizeDurationFromSeconds(Number(secondsText[1]));
  }

  return "";
};

export const deriveVideoDurationLabel = (property) => {
  const directLabel = normalizeDurationFromText(property?.video_duration_label);
  if (directLabel) {
    return directLabel;
  }

  const rawDuration = property?.video_duration_seconds ?? property?.video_duration;
  if (typeof rawDuration === "number") {
    return normalizeDurationFromSeconds(rawDuration);
  }

  if (typeof rawDuration === "string") {
    const normalized = normalizeDurationFromText(rawDuration);
    if (normalized) {
      return normalized;
    }
  }

  return "00:42";
};

export const deriveVideoQualityBadge = (property) => {
  const explicit =
    (property?.video_quality_label || property?.video_quality || "").toString().trim().toUpperCase();
  if (explicit === "4K" || explicit === "HD") {
    return explicit;
  }

  const url = (property?.video_url || "").toLowerCase();
  if (!url) {
    return null;
  }

  if (url.includes("4k") || url.includes("2160")) {
    return "4K";
  }

  if (url.includes("hd") || url.includes("1080") || url.includes("720")) {
    return "HD";
  }

  return null;
};
